import { FC, ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Container from '../components/Layout/Container';
import Logo from '../assets/Callmart logo.png';

interface StatusPageLayoutProps {
    title: ReactNode;
    message: ReactNode;
    children?: ReactNode;
}

const StatusPageLayout: FC<StatusPageLayoutProps> = ({ title, message, children }) => {
    return (
        <Container>
            <Stack direction="column" spacing={2} alignItems="center">
                <Box maxWidth="200px">
                    <img width="100%" src={Logo} alt="Callmart logo" />
                </Box>
                <Box textAlign="center">
                    <Typography variant="h2">{title}</Typography>
                    <Typography>{message}</Typography>
                </Box>
                {children}
            </Stack>
        </Container>
    );
};

export default StatusPageLayout;
